import { gql } from 'src/__generated__';

const CREATE_USER = gql(`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        id

        name
        lastnames
        email
        phoneNumber
        picture
      }
    }
  }
`);

export default CREATE_USER;
